export class AcumaticaLoginCredentials {
    constructor(
        readonly name: string,
        private password: string,
        readonly company: string = "",
        readonly branch: string = "",
        readonly local: string = "en-US"
    ) { }
}

export class AcumaticaLoginResult {
    constructor(
        readonly loggedin: boolean,
        readonly fromLogin: boolean = false,
        readonly error: string | null = null,
        readonly redirectLoggedOutToLogin: boolean = true
    ) { }
}